import { CmsVendor } from "@modules/graphql/types"
import { OnboardingSiteType } from "@modules/onboarding/shared/types"
import * as React from "react"
import { ConnectContentfulOrganizationForm } from "../../edition/components/ConnectContentfulOrganizationForm"

export type CmsProvisioningFormProps = {
  siteId: string
  siteName: string
  siteType: OnboardingSiteType
  cmsVendor: CmsVendor
  onComplete: () => void
  onCancel: () => void
  onFetchError: () => void
}

export function CmsProvisioningForm({
  siteId,
  siteName,
  siteType,
  cmsVendor,
  onComplete,
  onCancel,
  onFetchError,
}: CmsProvisioningFormProps) {
  const FormComponent = getProvisionCmsComponent(cmsVendor)

  React.useEffect(() => {
    if (!FormComponent) {
      onComplete()
    }
  }, [FormComponent])

  if (!FormComponent) {
    return null
  }

  return (
    <FormComponent
      siteId={siteId}
      siteName={siteName}
      siteType={siteType}
      onCancel={onCancel}
      onComplete={onComplete}
      onFetchError={onFetchError}
    />
  )
}

function getProvisionCmsComponent(cmsVendor: CmsVendor) {
  switch (cmsVendor) {
    case CmsVendor.Contentful:
      return ConnectContentfulOrganizationForm
    default:
      return null
  }
}
